export default __webpack_public_path__ + "static/media/Share.87270b3c.svg";